import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAdminMode, useUser } from '../providers/UserProvider';
import { ReaderNav } from './ReaderNav';

export function BetaReaderShell({
  children,
  exports,
  search,
  hideNavigation = false,
  brandTitle,
  feedSwitcher = false,
  storyHotkeys = false,
}: {
  children: ReactNode;
  exports?: { rss: string; markdown: string };
  search?: ReactNode;
  hideNavigation?: boolean;
  brandTitle?: string;
  feedSwitcher?: boolean;
  storyHotkeys?: boolean;
}) {
  const { isAdmin } = useUser();
  const { adminMode } = useAdminMode();
  return (
    <div className="beta-reader-page">
      <main className="beta-reader">
        {!hideNavigation && (
          <ReaderNav
            search={search}
            exports={exports}
            brandTitle={brandTitle}
            feedSwitcher={feedSwitcher}
            storyHotkeys={storyHotkeys}
          />
        )}
        {isAdmin && adminMode && <Link className="beta-admin-link" to="/admin">Admin tools</Link>}
        {children}
      </main>
    </div>
  );
}
